import React from "react";
import classNames from "classnames";
import styles from "./Alert.module.scss";

type AlertVariant = "default" | "cta" | "danger" | "warning";

interface AlertProps {
    variant?: AlertVariant;
    className?: string;
    children: React.ReactNode;
}

export const Alert: React.FC<AlertProps> = ({
    variant = "default",
    className,
    children,
}) => (
    <div
        className={classNames(
            styles.alert,
            styles[`alert--${variant}`],
            className,
        )}
        role="alert"
    >
        {children}
    </div>
);
